<template>
  <div class="mb-4">
    <div v-if="!successPay" class="bg-white" style="border-bottom: 3px solid #777">
      <div class="container">
        <div class="checkout-header">
          <div>
            <a @click.prevent="openModalCancel()" class="checkout-header__back" href="#">
              <i class="fa fa-arrow-left"></i>
              <small class="d-none d-lg-inline ml-2">Ir al evento</small>
            </a>
            <div class="d-none d-lg-block">
              <div class="media-event">
                <div class="media-event__img">
                  <img class="img-fluid" :src="eventImg" alt="img">
                </div>
                <div class="media-event__body">
                  <h3 class="media-event__title text-uppercase">
                    <b>{{ eventName }}</b>
                  </h3>
                  <div class="media-event__info">
                    <div class="mb-1">
                      <div class="d-inline-block px-2 rounded" style="background: #ccc">
                        <b>{{ versus.smallName }}</b>
                      </div>
                      <span class="ml-2">
                        {{ dateFirst }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              v-if="transaction.expirationDate"
              class="checkout-header__timer text-primary"
              :class="{'text-danger': alertTime}"
            >
              <div style="font-size: 35px">
                <Countdown
                  :date="transaction.expirationDate"
                  :alertTimeMin="3"
                  @onFinish="finishTime()"
                  @onAlert="onAlertTime($event)"
                ></Countdown>
              </div>
              <small v-if="!alertTime">¡Tienes tiempo de sobra!</small>
              <small v-else>¡Te queda poco tiempo!</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <!-- <img src="https://picsum.photos/1600/180" alt="banner" class="img-fluid"> -->
    </div>
    <div class="container mt-3" style="min-height: 73vh">
      <div v-if="!loadedData" style="min-height: 90vh">
        <Loader></Loader>
      </div>
      <div v-else class="row">
        <div class="col-lg-8">
          <div v-if="!successPay">
            <CardShadow v-if="step === 1">
              <UserDataBuyEvents
                :quantity="transaction.quantity"
                :activityId="eventId"
                :transactionId="transactionId"
                @submit="submitParticipants($event)"
              >
                <div v-if="errors.errorParticipants" class="mb-2 text-danger text-right">
                  {{ errors.errorParticipants }}
                </div>
              </UserDataBuyEvents>
            </CardShadow>
            <div v-if="step === 2">
              <CardShadow>
                <div class="card-header bg-white">
                  <h4 class="card-title mb-0">
                    Selecciona el método de pago
                  </h4>
                </div>
                <div class="card-body bg-light">
                  <div class="mb-3">
                    <h4>
                      <b class="text-danger">¡Importante!</b>
                    </h4>
                    <b>En caso ingreses una tarjeta distinta es posible que se te
                    haga una retención del monto de hasta por 25 días hábiles y no obtengas
                    las entradas.</b>
                  </div>
                  <p v-if="errors.errorTransaction" class="text-danger">
                    {{ errors.errorTransaction }}
                  </p>
                  <!-- pagoefectivo: online -->
                  <!-- <div v-if="hasMethod('pagoefectivo')" class="card mb-3 border-0">
                    <div class="p-3">
                      <div class="row align-items-center">
                        <div class="col-12 col-md-auto pr-0">
                          <img src="/images/methods/pe-online.png" width="130" alt="img">
                        </div>
                        <div class="col py-3">
                          <h5 class="text-uppercase- mb-0">
                            <b>Paga en tu banca en línea</b>
                          </h5>
                          <p class="small mb-0">
                            Paga con PagoEfectivo en cualquier banco a
                            través de tu banca en línea.
                            <br>
                            <b>Esta opción tiene un recargo de:</b>
                            <b class="text-danger"> + S/ 3.00</b>
                          </p>
                        </div>
                        <div class="col-12 col-md-auto">
                          <div class="pr-2">
                            <button
                              @click="payPagoEfectivo(true)"
                              :disabled="loading"
                              type="button"
                              class="btn btn-action btn-lg"
                            >
                              <b-spinner v-if="loadingPeOnline" small class="mr-1"></b-spinner>
                              <small>Solicitar Código</small>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="hasMethod('pagoefectivo')" class="card mb-3 border-0">
                    <div class="p-3">
                      <div class="row align-items-center">
                        <div class="col-12 col-md-auto pr-0">
                          <img src="/images/methods/pe-efectivo.png" width="130" alt="img">
                        </div>
                        <div class="col py-3">
                          <h5 class="text-uppercase- mb-0">
                            <b>Pago en efectivo</b>
                          </h5>
                          <p class="small mb-0">
                            Paga en efectivo con tu código de PagoEfectivo
                            en cualquier agente o banco.
                            <br>
                            <b>Esta opción tiene un recargo de:</b>
                            <b class="text-danger"> + S/ 3.00</b>
                          </p>
                        </div>
                        <div class="col-12 col-md-auto">
                          <div class="pr-2">
                            <button
                              @click="payPagoEfectivo()"
                              :disabled="loading"
                              type="button"
                              class="btn btn-action btn-lg"
                            >
                              <b-spinner v-if="loadingPeEfectivo" small class="mr-1"></b-spinner>
                              <small>Solicitar Código</small>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- visanet -->
                  <div v-if="hasMethod('visanet')" class="card mb-3 border-0">
                    <div class="p-3">
                      <div class="row align-items-center">
                        <div class="col-12 col-md-auto pr-0">
                          <img
                            src="https://s3-us-west-2.amazonaws.com/joinnus.com/files/metodos/PE/PE-VISA.svg"
                            width="130"
                            alt="img"
                          >
                        </div>
                        <div class="col py-3">
                          <h5 class="text-uppercase- mb-0">
                            <b>Tarjeta de Crédito o Débito</b>
                          </h5>
                          <p class="small mb-0">
                            Paga de forma segura con tu Tarjeta de Crédito o Débito.
                            <b>Venta exclusiva para tarjetas BBVA</b><br>
                          </p>
                        </div>
                        <div class="col-12 col-md-auto">
                          <div class="pr-2">
                            <div v-if="visanet.validPayment">
                              <form
                                id="formVisa"
                                ref="formVisa"
                                :action="visanetAction"
                                method="post"
                              >
                              </form>
                            </div>
                            <button
                              v-else
                              @click="payVisanet()"
                              :disabled="loading"
                              type="button"
                              class="btn btn-action btn-lg"
                              style="width: 160px"
                            >
                              <b-spinner v-if="visanetLoading" label="Spinning" small></b-spinner>
                              <small v-else>Pagar con Tarjeta</small>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- payu/mercadopago -->
                  <!-- <div v-if="hasMethod('mercadopago')" class="card mb-3 border-0">
                    <div class="p-3">
                      <div class="row align-items-center">
                        <div class="col-12 col-md-auto pr-0">
                          <img src="/images/methods/tarjeta.png" width="130" alt="img">
                        </div>
                        <div class="col py-3">
                          <h5 class="text-uppercase- mb-0">
                            <b>Tarjeta de Crédito o Débito</b>
                          </h5>
                          <p class="small mb-0">
                            Paga de forma segura con tu Tarjeta de Crédito o Débito.
                          </p>
                        </div>
                        <div class="col-12 col-md-auto">
                          <div class="pr-2">
                            <button
                              @click="payWithCard()"
                              :disabled="loading"
                              type="button"
                              class="btn btn-action btn-lg"
                            >
                              <small>Pagar con Tarjeta</small>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- Procesos de Pago - Mastercard American - Express - Diners -->
                  <div v-if="hasMethod('procesos-pago')" class="card mb-3 border-0">
                    <div class="p-3">
                      <div class="row align-items-center mb-3">
                        <div class="col-12">
                          <h5 class="mb-1">
                            <b>Otros métodos de pago</b>
                          </h5>
                          <p class="small mb-0">
                            Paga de forma segura con tu Tarjeta de Crédito o Débito.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div>
                          <form
                            id="formProcesosPagoMastercard"
                            ref="formProcesosPagoMastercard"
                            :action="actionProcessMastercard"
                            method="post"
                          >
                          </form>
                          <form
                            id="formProcesosPagoAmex"
                            ref="formProcesosPagoAmex"
                            :action="actionProcessAmex"
                            method="post"
                          >
                          </form>
                          <form
                            id="formProcesosPagoDiners"
                            ref="formProcesosPagoDiners"
                            :action="actionProcessDiners"
                            method="post"
                          >
                          </form>
                        </div>
                        <div class="form-row justify-content-center">
                          <div class="col-6 col-sm-4 mb-2">
                            <button
                              @click="procesosPagoProcess('mastercard')"
                              class="btn btn-payment-methods p-0 w-100"
                              :disabled="procesosPagoLoading"
                            >
                              <img
                                class="jn-payment-methods"
                                src="https://s3-us-west-2.amazonaws.com/joinnus.com/files/metodos/PE/PE-MASTERCARD.svg"
                                alt="mastercard"
                              >
                            </button>
                          </div>
                          <div class="col-6 col-sm-4 mb-2">
                            <button
                              @click="procesosPagoProcess('amex')"
                              class="btn btn-payment-methods p-0 w-100"
                              :disabled="procesosPagoLoading"
                            >
                              <img
                                class="jn-payment-methods"
                                src="https://s3-us-west-2.amazonaws.com/joinnus.com/files/metodos/PE/PE-AMEX.svg"
                                alt="amex"
                              >
                            </button>
                          </div>
                          <div class="col-6 col-sm-4 mb-2">
                            <button
                              @click="procesosPagoProcess('diners')"
                              class="btn btn-payment-methods p-0 w-100"
                              :disabled="procesosPagoLoading"
                            >
                              <img
                                class="jn-payment-methods"
                                src="https://s3-us-west-2.amazonaws.com/joinnus.com/files/metodos/PE/PE-DINERSCLUB.svg"
                                alt="diners"
                              >
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardShadow>
            </div>
          </div>
          <div v-else>
            <CardShadow v-if="!iframeUrl">
              <div class="card-body py-5">
                <h3 class="text-center">
                  <!--<b>¡Gracias!</b><br>-->
                  <span>
                    Tu pago está siendo procesado.
                  </span>
                </h3>
                <h6 class="text-center">
                  Este proceso puede durar máximo 30 minutos,
                  <br class="d-none d-lg-block">
                  usa tu código para verificar el estado de tu reserva.
                </h6>
                <div class="text-center mt-4">
                  <h5 class="mt-3">Tu código de reserva es</h5>
                  <div
                    class="d-inline-block px-5 py-1 rounded text-primary"
                    style="font-size: 40px; background: #eee"
                  >
                    <b>{{ transactionId }}</b>
                  </div>
                  <div class="mt-3">
                    <b-button
                      variant="primary"
                      v-clipboard:copy="transactionId"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <i class="fa fa-copy"></i>
                      <span> COPIAR CÓDIGO</span>
                    </b-button>
                    <span class="m-2 d-block d-sm-inline-block"></span>
                    <router-link
                      class ="btn btn-primary"
                      :to="{name: 'Verify', params: { id: transactionId } }"
                    >
                      <i class="fa fa-link"></i>
                      <span> IR A VERIFICAR</span>
                    </router-link>
                  </div>
                  <div class="small mt-3">
                    Tu código se envío al correo que ingresaste:
                    <b>{{ transaction.user.email }}</b>
                  </div>
                  <div class="small mt-1 text-success" v-if="textSuccessCopy">
                    Se copió el código con éxito
                  </div>
                  <div class="small mt-1 text-danger" v-if="textErrorCopy">
                    Ocurrio un error al copiar el código
                  </div>
                </div>
              </div>
            </CardShadow>
            <CardShadow v-else>
              <div class="card-body py-5">
                <h3 class="text-center">
                  <span>
                    Realiza el pago de tu código de PagoEfectivo
                  </span>
                </h3>
                <h6 class="text-center">
                  Recuerda que tienes hasta 45 minutos para realizarlo.
                </h6>
                <div class="row align-items-center justify-content-center mt-4">
                  <div class="col-auto">
                    <img src="/images/logo-pagoefectivo.png" alt="pe">
                  </div>
                  <div class="col-auto">
                    <div style="font-size: 30px">
                      Código de pago (CIP): <br>
                      <b>{{ parseInt(transaction.paymentTransactionId) }}</b>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-3">
                  <a
                    :href="iframeUrl"
                    target="_blank"
                    class="btn btn-primary btn-lg text-uppercase"
                  >
                    Ver formas de pago
                  </a>
                </div>
              </div>
            </CardShadow>
            <CardShadow v-if="iframeUrl">
              <div class="card-body py-5">
                <h3 class="text-center">
                  <span>
                    Una vez realizado el pago, usa tu
                    <br class="d-none d-lg-block">
                    <b>Código de Reserva para ver tus entradas</b>
                  </span>
                </h3>
                <div class="text-center mt-4">
                  <h5 class="mt-3">Tu código de reserva es</h5>
                  <div
                    class="d-inline-block px-5 py-1 rounded text-primary"
                    style="font-size: 35px; background: #eee"
                  >
                    <b>{{ transactionId }}</b>
                  </div>
                  <div class="mt-3">
                    <b-button
                      variant="primary"
                      v-clipboard:copy="transactionId"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <i class="fa fa-copy"></i>
                      <span> COPIAR CÓDIGO</span>
                    </b-button>
                  </div>
                  <div class="small mt-3">
                    Tu código se envío al correo que ingresaste:
                    <b>{{ transaction.user.email }}</b>
                  </div>
                  <div class="small mt-1 text-success" v-if="textSuccessCopy">
                    Se copió el código con éxito
                  </div>
                  <div class="small mt-1 text-danger" v-if="textErrorCopy">
                    Ocurrio un error al copiar el código
                  </div>
                </div>
              </div>
            </CardShadow>
            <CardShadow>
              <div class="card-body border-bottom">
                <div v-b-toggle="'collapse-restriciones'" class="d-block el-pointer">
                  <span class="float-right">
                    Ver
                  </span>
                  <h4 class="card-title mb-0">
                    ¿Para qué sirve mi código de reserva?
                  </h4>
                </div>
              </div>
              <b-collapse id="collapse-restriciones" accordion="accordion-info" visible>
                <div class="card-body bg-light">
                  El código de reserva, sirve para verificar el
                  estado del proceso de la transacción, con el
                  podrás saber si tu pago fue rechazado, está pendiente o fue aceptado.
                </div>
              </b-collapse>
            </CardShadow>
            <CardShadow>
              <div class="card-body border-bottom">
                <div v-b-toggle="'collapse-code'" class="d-block el-pointer">
                  <span class="float-right">
                    Ver
                  </span>
                  <h4 class="card-title mb-0">
                    ¿Dónde debo ingresar mi código de reserva?
                  </h4>
                </div>
              </div>
              <b-collapse id="collapse-code" accordion="accordion-info">
                <div class="card-body bg-light">
                  El código de reserva se ingresa en la página
                  de “MIS ENTRADAS” puedes dirigir ahí haciendo
                  <router-link :to="{name: 'Verify'}">
                    clic aquí.
                  </router-link>
                </div>
              </b-collapse>
            </CardShadow>
            <CardShadow>
              <div class="card-body border-bottom">
                <div v-b-toggle="'collapse-xq-code'" class="d-block el-pointer">
                  <span class="float-right">
                    Ver
                  </span>
                  <h4 class="card-title mb-0">
                    ¿Por qué tengo un código de reserva?
                  </h4>
                </div>
              </div>
              <b-collapse id="collapse-xq-code" accordion="accordion-info">
                <div class="card-body bg-light">
                  El código de reserva es indicador que se realizó la
                  reserva de las entradas y ahora se encuentra en espera
                  de la verificación del cobro de su tarjeta,
                  una vez aprobado el pago podrá ver sus entradas.
                  Si el cobro no se realiza perderá la reserva de sus entradas.
                </div>
              </b-collapse>
            </CardShadow>
          </div>
        </div>
        <div class="col-lg-4">
          <CardShadow>
            <div class="card-body">
              <div class="mb-3">
                <h6 class="text-uppercase small">
                  <b>{{ eventName }}</b>
                </h6>
                <span class="badge badge-primary p-1 px-2">
                  Deportes
                </span>
              </div>
              <div class="py-3 border-top small">
                <div class="mb-1">
                  <div class="d-inline-block px-2 rounded" style="background: #ccc">
                    <b>{{ versus.smallName }}</b>
                  </div>
                  <div class="mt-1">
                    {{ dateFirst }}
                  </div>
                </div>
              </div>
              <div class="py-3 border-top small">
                <i class="fa fa-map-marker"></i>
                <span class="ml-1">
                  {{ stadiumName }}
                </span>
                <span> - </span>
                <b>
                  LIMA, PE
                </b>
              </div>
              <div class="py-1 border-top border-bottom small mb-5">
                <div class="row no-gutters align-items-center">
                  <div class="col-auto">
                    <img src="/images/organizador.png" width="50" alt="FPF">
                  </div>
                  <div class="col">
                    <div class="card-body py-2">
                      <div class="card-title mb-0">
                        Organiza<br>
                        <b>Federación Peruana de Fútbol</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <h6 class="pb-3 border-bottom">
                  <b>Resumen de compra</b>
                </h6>
                <div class="pb-2 mb-2" style="border-bottom: 3px solid #333">
                  <div class="row align-items-end mb-2">
                    <div class="col">
                      <div class="d-inline-block px-2 rounded small" style="background: #ccc">
                        <b>{{ versus.smallName }}</b>
                      </div>
                      <div>
                        {{ transaction.quantity }} - {{ transaction.ticketName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="h5 mb-3">
                  <b>Total</b>
                  <b class="float-right">
                    S/ {{ transaction.paymentTotal }}
                  </b>
                </div>
              </div>
            </div>
          </CardShadow>
          <!-- <CardShadow>
            <img src="https://picsum.photos/800/180" alt="banner" class="img-fluid">
          </CardShadow> -->
        </div>
      </div>
    </div>
    <b-modal v-model="modalCancel" hide-footer hide-header>
      <div class="text-center my-4">
        <div class="mb-3">
          <img src="/images/logo-square.png" width="90" alt="Joinnus" class="rounded-circle">
        </div>
        <h5>¿Estás seguro que deseas salir de esta página?</h5>
        <p>Si sales perderás los datos que ya habías completado y tu reserva será liberada.</p>
        <p>Podrás volver a realizar una reserva en 15 minutos</p>
        <p class="mt-4">
          <button
            @click="cancelTicket()"
            :disabled="loading"
            type="button"
            class="btn btn-secondary mb-3"
          >
            Si, cancelar compra
          </button>
          <span class="d-none d-sm-inline mx-2">&nbsp;</span>
          <button @click="modalCancel = false" type="button" class="btn btn-primary mb-3">
            Seguir con la compra
          </button>
        </p>
      </div>
    </b-modal>
    <b-modal v-model="modalVerifyBin" hide-footer hide-header centered no-close-on-backdrop>
      <div class="text-center p-4">
        <h5>
          <b>
            Ingresa los 6 primeros dígitos
            <br class="d-none d-sm-block">
            de la tarjeta con la que vas a pagar
          </b>
        </h5>
        <p class="mb-4">
          <b>Importante:</b> Exclusivo para pago con tarjetas del BBVA.
        </p>
        <div v-if="specialBin">
          <h3 class="mb-4">
            Recuerda que con tu <b>Tarjeta del Hincha</b> tienes
            <b>15%</b> de descuento al momento de pagar.
          </h3>
          <p>
            <button
              @click="nextMethodPay()"
              type="button"
              class="btn btn-primary btn-lg px-5"
            >
              Ir a pagar
            </button>
          </p>
        </div>
        <form v-else @submit.prevent="verifyBin()">
          <div class="form-group mb-4">
            <input
              v-model="binPay"
              type="tel"
              class="form-control form-control-lg text-center"
              placeholder="6 primeros dígitos aquí"
              required
              minlength="6"
              maxlength="6"
            >
          </div>
          <p v-if="errors.errorBin" class="text-danger">
            {{ errors.errorBin }}
          </p>
          <div>
            <button
              @click="modalVerifyBin = false"
              type="button"
              class="btn btn-light mb-3"
            >
              Regresar
            </button>
            <span class="d-none d-sm-inline mx-2">&nbsp;</span>
            <button
              type="submit"
              class="btn btn-primary mb-3"
            >
              Continuar
            </button>
          </div>
        </form>
      </div>
    </b-modal>
    <b-modal
      v-model="modalPayCard"
      no-close-on-backdrop
      class="modal-pay"
      hide-footer
      hide-header
      centered
    >
      <FormPayCard
        currency="S/"
        :document-types="documentTypes"
        :email="transaction.user.email"
        :quantity="transaction.quantity"
        :paymentTotal="transaction.paymentTotal"
        :loading="loading"
        :card="card"
        :paymentMethodId="paymentMethodId"
        :msg-error="errors.errorTransaction"
        @hide="modalPayCard = false"
        @pay-method="payOnline('mercadopago')"
      >
      </FormPayCard>
    </b-modal>
  </div>
</template>

<script>
/* global userIp, Mercadopago, VisanetCheckout */
import $ from 'jquery';
import api from '../api';

import bines, { specialBines } from '../bines';

const {
  VUE_APP_API_CHECKOUT,
  VUE_APP_MERCADOPAGO_KEY,
} = process.env;

const documentTypes = [
  { value: null, text: 'Tipo de documento' },
  { value: 'DNI', text: 'DNI' },
  { value: 'CE', text: 'CE' },
  { value: 'RUC', text: 'RUC' },
  { value: 'PASS', text: 'PASS' },
];

const actionParams = () => {
  const { origin } = window.location;
  return `?baseUrl=${origin}&pathSuccess=/reserva&pathError=/visanet-error`;
};

export default {
  data() {
    return {
      documentTypes,
      step: 1,
      loadedData: false,
      loading: false, // loading pay card
      loadingPeOnline: false,
      loadingPeEfectivo: false,
      successPay: false,
      alertTime: false,
      modalPayCard: false,
      modalCancel: false,
      modalVerifyBin: false,
      binPay: '',
      okBin: false,
      specialBin: false,
      nextMethod: '',
      errors: {
        errorParticipants: '',
        errorTransaction: '',
        errorBin: '',
      },
      transactionId: null,
      transaction: {
        transactionId: '',
        paymentTotal: '',
        expirationDate: '',
        quantity: 0,
        ticketName: '',
        user: {
          email: '',
        },
        paymentMethods: [],
      },
      iframeUrl: '',
      participants: [],
      card: {
        number: '',
        name: '',
        expiry: '',
        cvc: '',
        documentType: null,
        document: '',
        type: 'debit',
        cardType: '',
        quota: null,
      },
      paymentMethod: '',
      // mercadopago
      paymentMethodId: '',
      paymentMethodToken: '',
      textSuccessCopy: false,
      textErrorCopy: false,
      // visanet
      visanetLoading: false,
      visanet: {
        validPayment: false,
        merchantId: null,
        token: null,
        session: null,
        channel: 'web',
        purchaseNumber: null,
        expirationTime: null,
      },
      // Procesos Pago
      procesosPagoLoading: false,
      procesosPago: {
        validPayment: false,
        brand: '',
        merchantId: null,
        numOrder: null,
        amount: null,
        currency: null,
        date: null,
        hour: null,
        random: null,
        clientCode: null,
        countryCode: null,
        hash: null,
      },
      actionProcessMastercard: null,
      actionProcessDiners: null,
      actionProcessAmex: null,
    };
  },
  created() {
    this.transactionId = this.$route.params.id || this.$route.query.id;
    this.visanet.merchantId = this.visanetMerchantId;
    this.procesosPago.merchantId = this.procesosPagoMerchantId;
    this.actionProcessMastercard = this.jsProcesosMastercard;
    this.actionProcessDiners = this.jsProcesosDiners;
    this.actionProcessAmex = this.jsProcesosAmex;
    this.getTicketDetail(this.transactionId);
  },
  computed: {
    visanetAction() {
      return `${VUE_APP_API_CHECKOUT}.1/payment/visa/${this.transactionId}${actionParams()}`;
    },
  },
  watch: {
    binPay() {
      this.errors.errorBin = '';
    },
  },
  methods: {
    verifyBin() {
      if (this.binPay.length < 6) return;
      this.okBin = false;
      this.specialBin = false;
      const digit = parseInt(this.binPay, 10);
      const bin = bines.find(item => item === digit);
      if (bin) {
        const binSpecial = specialBines.find(item => item === digit);
        this.okBin = true;
        if (binSpecial) {
          this.specialBin = true;
        } else {
          this.nextMethodPay();
        }
      } else {
        this.errors.errorBin = 'Usted no puede participar de la Pre-venta ya que no es cliente BBVA.';
      }
    },
    nextMethodPay() {
      this.modalVerifyBin = false;
      if (this.nextMethod === 'visanet') {
        this.payVisanet();
      } else {
        this.procesosPagoProcess(this.nextMethod);
      }
    },
    hasMethod(key) {
      const { paymentMethods } = this.transaction;
      if (!paymentMethods.length) return true;
      return paymentMethods.includes(key);
    },
    async getTicketDetail(transactionId) {
      this.loading = true;
      const url = `${api.nodeUrl}/reservation/detail`;
      const { data: res } = await api.axios.post(url, { transactionId });
      this.loading = false;
      this.loadedData = true;
      if (!res.status) {
        this.$router.push({ name: 'Verify', params: { id: transactionId } });
        return;
      }
      this.transaction = res.data;
      this.transaction.expirationDate = res.data.expirationDate;
      this.transaction.paymentTotal = res.data.paymentTotal.toFixed(2);
      if (res.data.process) {
        this.successPay = true;
        if (res.data.iframe) {
          this.iframeUrl = res.data.iframe;
        } else {
          this.transaction.expirationDate = '';
        }
      }
    },
    backRedirect() {
      this.$router.push({ name: 'Home' });
    },
    onAlertTime() {
      this.alertTime = true;
    },
    finishTime() {
      this.backRedirect();
    },
    openModalCancel() {
      this.modalCancel = true;
    },
    cancelTicket() {
      this.backRedirect();
    },
    payWithCard() {
      Mercadopago.setPublishableKey(VUE_APP_MERCADOPAGO_KEY);
      Mercadopago.getIdentificationTypes();
      this.modalPayCard = true;
    },
    payPagoEfectivo(online) {
      if (online) {
        this.loadingPeOnline = true;
      } else {
        this.loadingPeEfectivo = true;
      }
      this.payOnline('pagoefectivo');
    },
    resetLoadingPe() {
      this.loadingPeOnline = false;
      this.loadingPeEfectivo = false;
    },
    submitParticipants(data) {
      this.participants = data;
      this.step = 2;
    },
    payOnline(method) {
      this.paymentMethod = method;
      if (method === 'mercadopago') {
        this.payWithMercadopago();
      } else {
        this.payProccess();
      }
    },
    payWithMercadopago() {
      const bin = this.card.number.substring(0, 6);
      Mercadopago.getPaymentMethod({ bin }, this.setPaymentMethodInfo);
    },
    setPaymentMethodInfo(status, response) {
      if (status === 200) {
        this.paymentMethodId = response[0].id;
        const $form = document.querySelector('#pay');
        setTimeout(() => {
          Mercadopago.createToken($form, this.sdkResponseHandler);
        }, 250);
      } else {
        // eslint-disable-next-line
        console.log(`Payment method info error: ${response}`);
      }
    },
    sdkResponseHandler(status, response) {
      if (status !== 200 && status !== 201) {
        this.errors.errorTransaction = 'Verifica que los datos sean correctos.';
        this.resetErroMsg();
      } else {
        this.paymentMethodToken = response.id;
        setTimeout(() => {
          this.payProccess();
        }, 250);
      }
    },
    async payProccess() {
      const { paymentMethod } = this;
      this.loading = true;
      const {
        participants,
        card,
        transactionId,
      } = this;
      const payload = {
        transactionId,
        participants,
        payment: {
          deviceSessionID: window.deviceSessionIDPayU,
          ...card,
        },
        source: this.projectKey,
        activityId: this.eventId,
        paymentMethod,
        // data mercadopago next
        mercadopagoToken: this.paymentMethodToken,
      };
      const url = `${api.nodeUrl}/reservation/payment`;
      const token = this.signToken(payload);
      try {
        const { data: res } = await api.axios.post(url, { token });
        this.loading = false;
        this.resetLoadingPe();
        if (!res.status) {
          this.errors.errorTransaction = res.message;
          this.resetErroMsg();
          return;
        }
        this.modalPayCard = false;
        this.successPay = true;
        if (paymentMethod === 'pagoefectivo') {
          this.transaction.expirationDate = res.data.expiration;
          this.transaction.paymentTransactionId = res.data.paymentTransactionId;
          this.iframeUrl = res.data.iframe;
        }
      } catch (err) {
        this.loading = false;
        this.resetLoadingPe();
        this.errors.errorTransaction = err;
        this.resetErroMsg();
      }
    },
    resetErroMsg() {
      setTimeout(() => {
        this.errors.errorTransaction = '';
      }, 9000);
    },
    onCopy() {
      this.textSuccessCopy = true;
      this.textErrorCopy = false;
      setTimeout(() => {
        this.textSuccessCopy = false;
      }, 7000);
    },
    onError() {
      this.textErrorCopy = true;
      this.textSuccessCopy = false;
      setTimeout(() => {
        this.textErrorCopy = false;
      }, 5000);
    },
    setErrorTransaction(msg) {
      this.errors.errorTransaction = msg;
      setTimeout(() => {
        this.errors.errorTransaction = '';
      }, 9000);
    },
    getAmountTotal(total) {
      let amountTotal = total;
      if (this.specialBin) {
        const amountInt = parseFloat(amountTotal, 10);
        const discount = (amountInt * 15) / 100;
        amountTotal = (amountInt - discount).toFixed(2);
      }
      return amountTotal;
    },
    // visanet
    async payVisanet() {
      this.nextMethod = 'visanet';
      if (!this.okBin) {
        this.modalVerifyBin = true;
        return;
      }
      this.loading = true;
      this.visanetLoading = true;
      const isTicket = false;
      const ticketId = this.transactionId;
      const amountTotal = this.getAmountTotal(this.transaction.paymentTotal);

      const user = {
        ip: userIp,
        ipCountry: userIp,
        session: null,
        user_id: this.transaction.user.id,
      };
      const payload = {
        ticket: {
          id: ticketId,
        },
        payment: {
          amount: amountTotal,
          currency: 'PEN',
          creditType: 'visa',
        },
        user,
        isTicket,
      };
      const res = await api.axios.post(`${VUE_APP_API_CHECKOUT}.1/payment/attempts`, payload);
      if (res.data.success) {
        this.visanet.purchaseNumber = res.data.purchaseNumber;
        const amount = this.getAmountTotal(res.data.paymentTotal);
        const payload2 = { amount, ticketId, user };

        const resPay = await api.axios.post(`${VUE_APP_API_CHECKOUT}.1/payment/visa-token`, payload2);
        this.loading = false;
        this.visanetLoading = false;

        if (resPay.data.success) {
          this.okBin = false;
          this.specialBin = false;
          this.saveDataExtra();
          this.visanet.session = resPay.data.data.sessionKey;
          this.visanet.token = resPay.data.token;
          this.visanet.validPayment = true;

          setTimeout(() => {
            const scriptVisa = document.createElement('script');
            scriptVisa.setAttribute('data-channel', this.visanet.channel);
            scriptVisa.setAttribute('data-merchantid', this.visanet.merchantId);
            scriptVisa.setAttribute('data-purchasenumber', this.visanet.purchaseNumber);
            scriptVisa.setAttribute('data-sessiontoken', this.visanet.session);
            scriptVisa.setAttribute('data-amount', amount);
            scriptVisa.setAttribute('data-merchantlogo', 'https://www.joinnus.com/inc/v2/participant/images/joinnus-visanet.png');
            scriptVisa.setAttribute('data-buttonsize', 'MEDIUM');
            scriptVisa.setAttribute('data-expirationminutes', '15');
            scriptVisa.setAttribute('data-formbuttoncolor', '#57a692');
            scriptVisa.setAttribute('data-merchantname', 'Joinnus');
            scriptVisa.setAttribute('data-timeouturl', '/checkout');
            scriptVisa.setAttribute('src', this.jsVisanet);

            document.forms.formVisa.appendChild(scriptVisa);
            scriptVisa.onload = () => {
              VisanetCheckout.Button.prototype.open(this);
            };
          }, 300);
        } else {
          this.setErrorTransaction(resPay.data.message);
        }
      } else {
        this.setErrorTransaction(res.data.message);
        this.loading = false;
        this.visanetLoading = false;
      }
    },
    // mastercard - amex - diners
    async procesosPagoProcess(method) {
      this.nextMethod = method;
      if (!this.okBin && method === 'mastercard') {
        this.modalVerifyBin = true;
        return;
      }
      this.loading = true;
      this.procesosPagoLoading = true;

      const now = new Date();
      // Date
      const date = now.toISOString().slice(0, 10).replace(/-/g, '');
      // Hour
      const dateTime = now.toTimeString();
      let hour = dateTime.split(' ')[0];
      hour = hour.replace(/\b:\b/gi, '');

      const isTicket = false;
      const ticketId = this.transactionId;
      const amountTotal = this.getAmountTotal(this.transaction.paymentTotal);

      this.procesosPago.amount = amountTotal;
      this.procesosPago.currency = 'PEN';
      this.procesosPago.date = date;
      this.procesosPago.hour = hour;
      this.procesosPago.random = date + hour;
      this.procesosPago.clientCode = this.transaction.user.id;
      this.procesosPago.countryCode = 'PER';

      const user = {
        ip: userIp,
        ipCountry: userIp,
        session: null,
        user_id: this.transaction.user.id,
      };
      const payload = {
        ticket: {
          id: ticketId,
        },
        payment: {
          amount: amountTotal,
          currency: 'PEN',
          paymentMethod: 'procesos-pago',
          gateway: method,
        },
        user,
        isTicket,
      };
      const res = await api.axios.post(`${VUE_APP_API_CHECKOUT}.1/payment/attempts`, payload);
      if (res.data.success) {
        this.procesosPago.numOrder = res.data.purchaseNumber;
        const payload2 = {
          numOrder: this.procesosPago.numOrder,
          amount: this.procesosPago.amount,
          currency: this.procesosPago.currency,
          date: this.procesosPago.date,
          hour: this.procesosPago.hour,
          random: this.procesosPago.random,
          clientCode: this.procesosPago.clientCode,
          countryCode: this.procesosPago.countryCode,
        };
        const resPay = await api.axios.post(`${VUE_APP_API_CHECKOUT}/mastercard/mac`, payload2);
        this.loading = true;
        this.procesosPagoLoading = true;

        if (resPay.data.success) {
          if (!resPay.data.hash) {
            this.loading = false;
            return;
          }
          this.procesosPago.hash = resPay.data.hash;
          this.procesosPago.clientCode = resPay.data.clientCode;
          this.saveDataExtra();

          setTimeout(() => {
            const inputProcesosPagoI1 = document.createElement('input');
            const inputProcesosPagoI2 = document.createElement('input');
            const inputProcesosPagoI3 = document.createElement('input');
            const inputProcesosPagoI4 = document.createElement('input');
            const inputProcesosPagoI5 = document.createElement('input');
            const inputProcesosPagoI6 = document.createElement('input');
            const inputProcesosPagoI7 = document.createElement('input');
            const inputProcesosPagoI8 = document.createElement('input');
            const inputProcesosPagoI9 = document.createElement('input');
            const inputProcesosPagoI10 = document.createElement('input');

            inputProcesosPagoI1.setAttribute('type', 'hidden');
            inputProcesosPagoI2.setAttribute('type', 'hidden');
            inputProcesosPagoI3.setAttribute('type', 'hidden');
            inputProcesosPagoI4.setAttribute('type', 'hidden');
            inputProcesosPagoI5.setAttribute('type', 'hidden');
            inputProcesosPagoI6.setAttribute('type', 'hidden');
            inputProcesosPagoI7.setAttribute('type', 'hidden');
            inputProcesosPagoI8.setAttribute('type', 'hidden');
            inputProcesosPagoI9.setAttribute('type', 'hidden');
            inputProcesosPagoI10.setAttribute('type', 'hidden');

            inputProcesosPagoI1.setAttribute('name', 'I1');
            inputProcesosPagoI2.setAttribute('name', 'I2');
            inputProcesosPagoI3.setAttribute('name', 'I3');
            inputProcesosPagoI4.setAttribute('name', 'I4');
            inputProcesosPagoI5.setAttribute('name', 'I5');
            inputProcesosPagoI6.setAttribute('name', 'I6');
            inputProcesosPagoI7.setAttribute('name', 'I7');
            inputProcesosPagoI8.setAttribute('name', 'I8');
            inputProcesosPagoI9.setAttribute('name', 'I9');
            inputProcesosPagoI10.setAttribute('name', 'I10');

            inputProcesosPagoI1.setAttribute('value', this.procesosPago.merchantId);
            inputProcesosPagoI2.setAttribute('value', this.procesosPago.numOrder);
            inputProcesosPagoI3.setAttribute('value', this.procesosPago.amount);
            inputProcesosPagoI4.setAttribute('value', this.procesosPago.currency);
            inputProcesosPagoI5.setAttribute('value', this.procesosPago.date);
            inputProcesosPagoI6.setAttribute('value', this.procesosPago.hour);
            inputProcesosPagoI7.setAttribute('value', this.procesosPago.random);
            inputProcesosPagoI8.setAttribute('value', this.procesosPago.clientCode);
            inputProcesosPagoI9.setAttribute('value', this.procesosPago.countryCode);
            inputProcesosPagoI10.setAttribute('value', this.procesosPago.hash);

            if (method === 'mastercard') {
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI1);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI2);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI3);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI4);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI5);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI6);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI7);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI8);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI9);
              document.forms.formProcesosPagoMastercard.appendChild(inputProcesosPagoI10);
              $('#formProcesosPagoMastercard').submit();
            } else if (method === 'diners') {
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI1);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI2);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI3);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI4);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI5);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI6);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI7);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI8);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI9);
              document.forms.formProcesosPagoDiners.appendChild(inputProcesosPagoI10);
              $('#formProcesosPagoDiners').submit();
            } else if (method === 'amex') {
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI1);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI2);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI3);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI4);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI5);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI6);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI7);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI8);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI9);
              document.forms.formProcesosPagoAmex.appendChild(inputProcesosPagoI10);
              $('#formProcesosPagoAmex').submit();
            }
            setTimeout(() => {
              this.loading = false;
            }, 8000);
          }, 500);
        } else {
          this.setErrorTransaction(resPay.data.message);
          this.loading = false;
          this.procesosPagoLoading = false;
        }
      } else {
        this.setErrorTransaction(res.data.message);
        this.loading = false;
        this.procesosPagoLoading = false;
      }
    },
    async saveDataExtra() {
      const { ticketName, ticketTypeId } = this.transaction;
      const dataParticipants = this.participants.map(el => ({
        name: el.name,
        lastName: el.lastName,
        email: el.email,
        documentType: el.documentType,
        document: el.document,
        showChild: el.isChild,
        type: ticketName,
        idTicketType: ticketTypeId,
        phone: '',
      }));
      const payload = {
        user: {},
        ticket: {
          id: this.transactionId,
        },
        payload: {
          dataExtraFields: [],
          dataBilling: [],
          dataParticipants: {
            static: dataParticipants,
            extra: [],
          },
        },
      };
      const token = this.signToken(payload);
      const url = `${VUE_APP_API_CHECKOUT}.1/fpf/payment/save-data`;
      await api.axios.post(url, { details: token });
    },
  },
};
</script>
